import React from 'react';
import type { NetworkType } from '@mls-wallet/shared-types';
import { GeneralizedContractCard } from './GeneralizedContractCard';
import type { DecodedParameterNode } from './decoders';

interface NestedDecodedValue {
  data?: string;
  value?: string;
  to: string;
  contractName?: string;
  dataDecoded?: {
    method?: string;
    parameters?: DecodedParameterNode[];
  };
}

interface ValueDecodedCardProps {
  decodedValue: NestedDecodedValue;
  networkId: NetworkType;
  index?: number;
}

/**
 * Render a decoded value (nested contract call) using the generalized card.
 * Simplified vs self-custody: custom modes and simulations omitted for now.
 */
export function ValueDecodedCard({
  decodedValue,
  networkId,
}: ValueDecodedCardProps): React.ReactElement {
  const parameters = decodedValue.dataDecoded?.parameters ?? [];
  const functionName = decodedValue.dataDecoded?.method ?? 'Unknown';

  return (
    <div className="w-full">
      <GeneralizedContractCard
        functionName={functionName}
        contractAddress={decodedValue.to}
        {...(decodedValue.contractName
          ? { contractName: decodedValue.contractName }
          : {})}
        {...(decodedValue.value
          ? { nativeTokenValue: { value: decodedValue.value, decimals: 18 } }
          : {})}
        networkId={networkId}
        parameters={parameters}
      />
    </div>
  );
}
